import { Injectable } from '@angular/core';
import { ApplicationStorageService, AuthenticationService } from '@tt-chvac/authentication';
import { FeatureEnum, RoleService, UserInfoService } from '@tt-chvac/core-sales-web';

@Injectable({ providedIn: 'root' })
export class AuthorizeAccessService {

  constructor(
    private roleService: RoleService, private userInfoService: UserInfoService, private authenticationService: AuthenticationService,
    private applicationStorageService: ApplicationStorageService) {
  }

  /**
   * Determines whether user has readonly group
   * @param accessType as FeatureEnum
   * @returns true if readonly user
   */
  isReadOnlyUser(accessType: FeatureEnum): boolean {
    const groups = this.userInfoService.getUserRoles() ?? this.applicationStorageService.getTokenClaimsFromStorage()?.Groups;
    // TODO: Need to replace with entitlement api
      // TODO: Selva
    if (!groups) {
      //this.authenticationService.logout();
      return;
    }

    if (localStorage.getItem('userHasSalesOffice') === 'true') {
      return false;
    }

    this.roleService.userRoles = [...groups];

    const featureAccessDetails = this.roleService.getAccessesByFeature(accessType);
    // If user has any edit access in the credit project active directory group list then return false
    return featureAccessDetails?.length > 0 ? featureAccessDetails.filter(item => item.hasEdit).length === 0 : false;
  }

  /**
   * Determines whether user has specific feature access
   * @param feature as FeatureEnum
   * @returns true if user has specific feature access else false
   */
  hasFeatureAccess(feature: FeatureEnum): boolean {
    const groups = this.userInfoService.getUserRoles() ?? this.applicationStorageService.getTokenClaimsFromStorage()?.Groups;
    if (!groups) {
      this.authenticationService.logout();
      return;
    }
    this.roleService.userRoles = [...groups];
    const featureAccessDetails = this.roleService.getAccessesByFeature(feature);
    return featureAccessDetails?.length > 0;
  }
}
